<template>
  <v-carousel hide-delimiter-background cycle hide-controls hide-delimiters :show-arrows="false" v-if="items.length > 0" class="mb-4">
    <v-carousel-item v-for="(item, i) in items" :key="i" @click="redirectToExternalSite(item.link)">
      <v-img :src="item.src" :aspect-ratio="16 / 9" />
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: 'img/carousel/1.png',
          link: "https://leasing.express"
        },
        {
          src: 'img/carousel/2.png',
          link: 'https://leasing.express'
        },
        {
          src: 'img/carousel/3.png',
          link: 'https://bystrodengi.kg'
        },
      ],
    };
  },
  methods: {
    redirectToExternalSite(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style scoped>
@media(max-width: 600px) {
  .v-carousel {
    max-height: 180px;
  }
}
</style>